/**
 * RoleGuard – Route-level guard dựa trên role_code
 * v2: Check TẤT CẢ roles của user (multi-role), không chỉ primary role
 * Bảo vệ các role-specific dashboards khỏi truy cập trực tiếp qua URL
 */
import { Navigate } from 'react-router-dom';
import { useCurrentUser } from '@/shared/hooks/useCurrentUser';
import { useAuth } from '@/core/auth/AuthContext';
import type { UserRole } from '@/config/navigation.config';

interface RoleGuardProps {
  allowedRoles: UserRole[];
  children: React.ReactNode;
  redirectTo?: string;
}

export function RoleGuard({ allowedRoles, children, redirectTo = '/' }: RoleGuardProps) {
  const { user, isLoading, allRoleCodes } = useCurrentUser();
  const { user: authUser } = useAuth();

  // Chờ profile load xong
  if (isLoading || (authUser && !user.id)) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="flex items-center gap-2 text-gray-500 text-sm">
          <div className="w-4 h-4 border-2 border-green-500 border-t-transparent rounded-full animate-spin" />
          Đang kiểm tra quyền...
        </div>
      </div>
    );
  }

  // Super Admin bypass (optional - if we want super_admin to see everything)
  if (user.roleCode === 'super_admin') {
    return <>{children}</>;
  }

  // Multi-role: cho phép nếu BẤT KỲ role nào trong allRoleCodes khớp allowedRoles
  const hasAllowedRole = allRoleCodes.some(r => allowedRoles.includes(r));
  if (!hasAllowedRole) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
